import * as firebase from 'firebase';

const config = {
  apiKey: 'AIzaSyCL9LXVfEzDIyV7UKtpQbirSCR-2xgxr58',
  authDomain: 'mosi-c7699.firebaseapp.com',
  databaseURL: 'https://mosi-c7699.firebaseio.com',
  projectId: 'mosi-c7699',
  storageBucket: 'mosi-c7699.appspot.com',
  messagingSenderId: '1057395007559',
  appId: '1:1057395007559:web:b914d8fb2e79fa4a1cd162',
  measurementId: 'G-18B52QXZ2C',
};

firebase.initializeApp(config);
firebase.analytics();
const provider = new firebase.auth.GoogleAuthProvider();

export async function loginUser(email: string, password: string) {
  try {
    const res = await firebase
      .auth()
      .signInWithEmailAndPassword(email, password);
    console.log(res);
    return res?.user?.email;
  } catch (e) {
    console.log(e);
    return false;
  }
}

export async function registerUser(email: string, password: string) {
  try {
    const res = await firebase
      .auth()
      .createUserWithEmailAndPassword(email, password);
    console.log(res);
    return res?.user?.email;
  } catch (e) {
    console.log(e);
    return false;
  }
}

export async function loginGoogleUser() {
  try {
    const result = await firebase.auth().signInWithPopup(provider);
    //@ts-ignore
    let token = result?.credential?.accessToken;
    // The signed-in user info.
    let user = result.user;
    console.log(user, token);
    return user?.email;
  } catch (e) {
    console.log(e);
    return false;
  }
}
